__turbopack_context__.v({
  "freeBox___1QaD": "PlasmicReview-module__2IJsGW__freeBox___1QaD",
  "freeBox__ey73D": "PlasmicReview-module__2IJsGW__freeBox__ey73D",
  "freeBox__jHv8Y": "PlasmicReview-module__2IJsGW__freeBox__jHv8Y",
  "freeBox__pZuId": "PlasmicReview-module__2IJsGW__freeBox__pZuId",
  "root": "PlasmicReview-module__2IJsGW__root",
  "slotTargetChildren": "PlasmicReview-module__2IJsGW__slotTargetChildren",
  "slotTargetSlot2": "PlasmicReview-module__2IJsGW__slotTargetSlot2",
  "svg___0H4Lx": "PlasmicReview-module__2IJsGW__svg___0H4Lx",
  "svg__cbgTr": "PlasmicReview-module__2IJsGW__svg__cbgTr",
  "svg__dx5P7": "PlasmicReview-module__2IJsGW__svg__dx5P7",
  "svg__eEam": "PlasmicReview-module__2IJsGW__svg__eEam",
  "svg__na4Ng": "PlasmicReview-module__2IJsGW__svg__na4Ng",
});
